import { render, staticRenderFns } from "./OneThirdBannerBox.vue?vue&type=template&id=64383a6a"
import script from "./OneThirdBannerBox.vue?vue&type=script&lang=js"
export * from "./OneThirdBannerBox.vue?vue&type=script&lang=js"
import style0 from "./OneThirdBannerBox.vue?vue&type=style&index=0&id=64383a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports